/**
 * Vendor & UND WordPress Theme Constants
 * -----------------------------------------------------------------------------
 *
 * Importing vendor constants here allows us to override values if needed,
 * shortens the import/require path, and add WP Theme specific constants while
 * providing a single resource for constants.
 *
 * Examples
 * --------
 * 
 * _.CONDENSED_NAV_HEIGHT = 55;      // Override vendor example.
 * _.UND_WP_VERSION       = '1.0.0'; // WP specific example.
 * 
 */

// Imports.
const _ = require( '../../../../../vendor/und/js/utilities/_constants' );



// UND WP Theme Constants.
_.SVGSTORE_HASH = 2;



module.exports = _;